module.exports = __webpack_public_path__ + "img/box-mulino.763d39de.png";